var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-sheet",style:({
    'bottom': _vm.offsetBottom+'px',
    'height': (_vm.value) ? _vm.height+'px' : 0,
    'z-index': _vm.zIndex,
    'background-color': _vm.color,
  })},[_c('div',{ref:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }